import React from 'react';
import Grid from '@mui/material/Grid';
import { SelectComponent as Select } from '../../components/Select/Select';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';

import { sx } from './CallsheetHeaderStyles';

interface CallsheetHeaderProps {
    currentShootingDay?: string;
    shootingDays?: string[];
    setCurrentShootingDay: (day: string) => void;
    scenesPlanned: number;
    realShootingDays: number;
    completedScenes: number;
    totalSceneCoverage: number;
    totalOfCoveredLines?: number;
    totalOfPlannedScriptLines?: number;
}

export function CallsheetHeader (props: CallsheetHeaderProps) {
  const {
    currentShootingDay,
    shootingDays,
    setCurrentShootingDay,
    scenesPlanned,
    realShootingDays,
    completedScenes,
    totalSceneCoverage,
    totalOfPlannedScriptLines,
    totalOfCoveredLines,
  } = props;
  
  const shootingDayOptions = shootingDays?.concat('All Days').map((day) => day.toString()) || [];
  const plannedDays = shootingDays?.length || 0;

  return (
    <Grid container sx={sx.root}>
      <Grid item xs={3} sx={sx.gridItem}>
        <Stack direction="column" spacing={1} sx={sx.crewInfo}>
          <Typography variant="subtitle1">
            Director: Marc G Ros
          </Typography>
          <Typography variant="subtitle1">
            DOP: Neil Murphy
          </Typography>
          <Typography variant="subtitle1">
            Producer: Aleix Singla
          </Typography>
          <Typography />
        </Stack>
      </Grid>
      <Grid item xs={7} sx={sx.gridItem}>
        <Grid container>
          <Grid item xs={3}>
            <Stack direction="column">
              <Typography variant="subtitle1">
                Planned Days: {plannedDays}
              </Typography>
              <Typography variant="subtitle1">
                Real Days: {realShootingDays || 0}
              </Typography>
              <Typography variant="subtitle1">
                Pending days: {plannedDays - realShootingDays}
              </Typography>
              <Typography variant="subtitle1">
                % Completed: {plannedDays ? Math.round(realShootingDays / plannedDays * 100) : 0}%
              </Typography>
            </Stack>
          </Grid>
          <Grid item xs={3}>
            <Stack direction="column">
              <Typography variant="subtitle1">
                Scenes planned: {scenesPlanned || 0}
              </Typography>
              <Typography variant="subtitle1">
                Scenes shot: {completedScenes || 0}
              </Typography>
              <Typography variant="subtitle1">
                Scenes pending: {(scenesPlanned && completedScenes) ? scenesPlanned - completedScenes : 0}
              </Typography>
              <Typography variant="subtitle1">
                % Completed: {totalSceneCoverage ? Math.round(totalSceneCoverage) : 0}%
              </Typography>
            </Stack>
          </Grid>
          <Grid item xs={3}>
            <Typography variant="subtitle1">
                Script lines planned: {totalOfPlannedScriptLines || 0}
              </Typography>
              <Typography variant="subtitle1">
                Script lines shot: {totalOfCoveredLines || 0}
              </Typography>
              <Typography variant="subtitle1">
                Script lines pending: {(totalOfPlannedScriptLines || 0) - (totalOfCoveredLines || 0)}
              </Typography>
              <Typography variant="subtitle1">
                % Completed: {totalOfPlannedScriptLines ? Math.round(((totalOfCoveredLines || 0) / totalOfPlannedScriptLines) * 100) : 0}%
              </Typography>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={2} sx={sx.gridItem}>
        <Select
          options={shootingDayOptions} title="Shooting day"
          value={currentShootingDay || ''}
          setValue={(shootingDay) => setCurrentShootingDay(shootingDay)}
          size="small"
        />
      </Grid>
    </Grid>
  )
}
